export default __webpack_public_path__ + "static/aleph-beta-logo-white-c56fcddd896eec0a230bca6fcbdb151c.svg";